<template>
  <div class="wrapper">
    <img :src="company.logo_url" :alt="company.trading_name" class="company-logo">

    <CRMHeader></CRMHeader>

    <b-container class="mt-3 mb-3">
      <slot></slot>
    </b-container>
  </div>
</template>

<script>
import CRMHeader from '@/components/CRMHeader/CRMHeader.vue';

export default {
  components: {
    CRMHeader,
  },
};
</script>

<style lang="scss" scoped>
  .wrapper {
    background: rgba(249, 249, 249, .8);
    min-height: 100vh;
    min-width: 100vw;

    .company-logo {
      display: block;
      left: 50%;
      position: absolute;
      top: 50%;
      transform: translate(-50%, -50%);
      width: 50%;
      opacity: 10%;
      z-index: -1;
    }
  }
</style>
